import puma2600 from '../components/images/puma-2600.webp';
import puma3100 from '../components/images/Puma-3100.webp';
import tornado from '../components/images/Tornado.webp';
import alpha from '../components/images/Alpha.webp';
import VM10Ui from '../components/images/VM10Ui.webp';
import VMX42Ui from '../components/images/VMX42Ui.webp';
import VMX30Ui from '../components/images/VMX30Ui.webp';
import VMX30i from '../components/images/VMX30i.webp';
import VMX42i from '../components/images/VMX42i.webp';
import z48 from '../components/images/Z48.webp';
import zt612 from '../components/images/ZT612.webp';
import bub from '../components/images/BUB.webp';
import grindor from '../components/images/Grindor.webp';
import cmm from '../components/images/3D.webp';
import vyskomer from '../components/images/vyskomer.webp';
import drsnomer from '../components/images/drsnomer.webp';
import kruhomer from '../components/images/kruhomer.webp';

// Hodnota specifikace je buď text, nebo { key } pro přeložitelnou hodnotu (machines.values.*).
// Název stroje je buď text, nebo { key } (machines.names.*).
export const MACHINE_CATEGORIES = {
  lathe: {
    path: '/lathe-machines',
    groups: [
      {
        specs: ['maxTurnDia', 'maxTurnLen', 'maxSpindle'],
        items: [
          { name: 'Doosan Puma GT 2600LM', image: puma2600, values: ['Ø 460 mm', '1620 mm', '3500 min⁻¹'] },
          { name: 'Harrison Alpha 1460S', image: alpha, values: ['Ø 460 mm', '2000 mm', '2200 min⁻¹'] },
          { name: 'Doosan Puma 3100XLY', image: puma3100, values: ['Ø 420 mm', '2120 mm', '2800 min⁻¹'] },
          { name: 'Colchester Tornado 600 Group', image: tornado, values: ['Ø 300 mm', '500 mm', '5000 min⁻¹'] },
        ],
      },
    ],
  },
  milling: {
    path: '/milling-machines',
    groups: [
      {
        specs: ['tableSize', 'maxLoad', 'rangeXYZ'],
        items: [
          { name: 'Hurco VMX42Ui', image: VMX42Ui, values: ['Ø 400 mm', '250 kg', '1060 × 610 × 520 mm (+30° / −110° × 360°)'] },
          { name: 'Hurco VMX30Ui', image: VMX30Ui, values: ['Ø 250 mm', '200 kg', '760 × 505 × 520 mm (+30° / −110° × 360°)'] },
          { name: 'Hurco VMX30i', image: VMX30i, values: ['1000 × 500 mm', '1500 kg', '760 × 500 × 610 mm'] },
          { name: 'Hurco VMX42i', image: VMX42i, values: ['1250 × 610 mm', '1750 kg', '1060 × 610 × 610 mm'] },
          { name: 'Hurco VM10Ui', image: VM10Ui, values: ['Ø 450 mm', '150 kg', '530 × 405 × 480 mm (+30° / −110° × 360°)'] },
        ],
      },
    ],
  },
  grinding: {
    path: '/grinding-machines',
    groups: [
      {
        titleKey: 'machines.grinding.flat',
        specs: ['tableSize', 'maxLoad', 'workRange'],
        items: [
          { name: 'Ziersch Z48', image: z48, values: ['800 × 400 mm', '700 kg', '1200 × 450 × 600 mm'] },
          { name: 'Ziersch ZT612', image: zt612, values: ['1200 × 600 mm', '1300 kg', '1600 × 650 × 600 mm'] },
        ],
      },
      {
        titleKey: 'machines.grinding.round',
        specs: ['maxDia', 'maxLen', 'spindle'],
        items: [
          { name: 'BUB 40 NC', image: bub, values: ['Ø 400 mm', '1700 mm', '300 min⁻¹'] },
          { name: 'Junker Grindor Allround', image: grindor, values: ['Ø 280 mm', '800 mm', '500 min⁻¹'] },
        ],
      },
    ],
  },
  control: {
    path: '/control',
    groups: [
      {
        specs: ['accuracy', 'measRange', 'interface'],
        items: [
          { name: { key: 'cmm' }, image: cmm, values: ['0,1 µm', '500 × 500 × 300 mm', { key: 'digital' }] },
          // TODO: doplnit skutečné parametry výškoměru, drsnoměru a kruhoměru – do té doby se zobrazí bez tabulky.
          { name: { key: 'height' }, image: vyskomer },
          { name: { key: 'roughness' }, image: drsnomer },
          { name: { key: 'roundness' }, image: kruhomer },
        ],
      },
    ],
  },
};

export const CATEGORY_ORDER = ['lathe', 'milling', 'grinding', 'control'];
